export const textTransform = (text, transformTo) => {
  return <div style={{ textTransform: transformTo }}>{text}</div>;
};
